import { Colors } from "../../../../../../shared/theme";
import { textStyles } from "../../../../../../shared/theme/fonts-ppv";

export default {
    headerStyle: {
        ...textStyles.subtitle1,
        color: Colors.grey600,
        paddingBottom: '16px',
        marginBottom: '16px',
    }
}